import React from 'react';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  return <section className="py-10 md:py-14 px-4 bg-gray-50" data-id="element-204">
      <div className="max-w-3xl mx-auto" data-id="element-205">
        <div className="text-center" data-id="element-206">
          <h2 className="text-2xl md:text-4xl font-black text-gray-900 mb-3" data-id="element-207">
            💡 Presentamos
          </h2>
          <h3 className="text-3xl md:text-5xl font-black text-red-600 mb-3" data-id="element-208">
            ❤️ PACK 100 CITAS
          </h3>
          <p className="text-gray-500 italic mb-6 text-sm md:text-base" data-id="element-209">
            El sistema que transforma ratos libres en recuerdos que duran toda
            la vida.
          </p>

          <div className="bg-white p-5 md:p-6 rounded-2xl shadow-md border-2 border-dashed border-blue-200 mb-10" data-id="element-210">
            <p className="text-lg md:text-xl font-bold text-gray-800 mb-5" data-id="element-211">
              Un sistema simple de momentos guiados diseñado para que conectes
              de verdad con tus hijos — sin esfuerzo, sin pantallas y sin
              excusas.
            </p>
            <ul className="text-left space-y-3 text-base md:text-lg text-gray-600 max-w-xl mx-auto font-medium" data-id="element-212">
              <li className="flex items-start gap-3" data-id="element-213">
                <span className="text-red-500" data-id="element-214">❌</span> No es un libro teórico
                que vas a dejar en un cajón.
              </li>
              <li className="flex items-start gap-3" data-id="element-215">
                <span className="text-red-500" data-id="element-216">❌</span> No es un manual largo
                que nunca vas a terminar.
              </li>
              <li className="flex items-start gap-3 text-gray-900 font-bold bg-yellow-100 p-2 rounded" data-id="element-217">
                <span className="text-green-500" data-id="element-218">✅</span> Es un sistema
                práctico que podés usar hoy mismo. Abrís, elegís y conectás.
              </li>
            </ul>
          </div>

          <h3 className="text-2xl md:text-3xl font-black text-gray-900 mb-2" data-id="element-219">
            Así de simple funciona
          </h3>
          <p className="text-gray-500 mb-8 text-sm md:text-base" data-id="element-220">
            En 3 pasos ya estás creando recuerdos.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-8" data-id="element-221">
            <div className="bg-white p-4 md:p-5 rounded-xl shadow-sm border-t-2 border-blue-500" data-id="element-222">
              <div className="text-3xl mb-3" data-id="element-223">📖</div>
              <h4 className="text-lg font-bold text-gray-900 mb-1" data-id="element-224">
                Abrís el libro
              </h4>
              <p className="text-sm text-gray-600" data-id="element-225">
                Sin complicaciones.
                <br data-id="element-226" />
                Sin preparar nada.
              </p>
            </div>

            <div className="bg-white p-4 md:p-5 rounded-xl shadow-sm border-t-2 border-yellow-500 relative" data-id="element-227">
              <div className="absolute -right-3 top-1/2 transform -translate-y-1/2 hidden md:block text-gray-300 text-3xl" data-id="element-228">
                ➔
              </div>
              <div className="text-3xl mb-3" data-id="element-229">👆</div>
              <h4 className="text-lg font-bold text-gray-900 mb-1" data-id="element-230">
                Elegís una cita
              </h4>
              <p className="text-sm text-gray-600" data-id="element-231">
                Actividades pensadas para cada vínculo.
              </p>
            </div>

            <div className="bg-white p-4 md:p-5 rounded-xl shadow-sm border-t-2 border-red-500 relative" data-id="element-232">
              <div className="absolute -left-3 top-1/2 transform -translate-y-1/2 hidden md:block text-gray-300 text-3xl" data-id="element-233">
                ➔
              </div>
              <div className="text-3xl mb-3" data-id="element-234">❤️</div>
              <h4 className="text-lg font-bold text-gray-900 mb-1" data-id="element-235">
                Vivís el momento
              </h4>
              <p className="text-sm text-gray-600" data-id="element-236">
                Sin pantallas.
                <br data-id="element-237" />
                Sin estrés.
                <br data-id="element-238" />
                <span className="font-bold text-red-600" data-id="element-239">
                  Solo conexión real.
                </span>
              </p>
            </div>
          </div>

          <p className="text-gray-500 italic text-xs md:text-sm mb-6" data-id="element-240">
            "No necesitás ser el padre perfecto. Solo necesitás estar presente."
          </p>

          <CTAButton text="👉 QUIERO EMPEZAR A CREAR RECUERDOS HOY" data-id="element-241" />
        </div>
      </div>
    </section>;
}